<script>
import { Bar } from "vue-chartjs";
export default {
  extends: Bar,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    componentkey: Number
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
  watch: {
    componentkey() {
      this.renderChart(this.chartdata, this.options);
    }
  }
};
</script>